module.exports = __webpack_public_path__ + "static/Graphik-Bold-Web-a30da42f1a055b82ca2c459d520f8c3c.woff2";